var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar',{attrs:{"role":"navigation"}}),_vm._v(" "),_c('div',{attrs:{"role":"main"}},[_c('nuxt')],1),_vm._v(" "),_c('lazy-footer',{attrs:{"role":"contentinfo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }